// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"7edf1a4c","590":"b8bd75ec","655":"98476303"}[chunkId] + ".chunk.js";
};